import React, { useState, useEffect } from 'react';
import { FileCode, Loader2 } from 'lucide-react';
import { buildAPI } from '../lib/api';

export default function CodeBrowser({ buildId, files = [] }) {
  const [selected, setSelected] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const sorted = [...files].sort();

  useEffect(() => {
    if (!selected && sorted.length > 0) {
      const readme = sorted.find((f) => f.toLowerCase() === 'readme.md') || sorted[0];
      openFile(readme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  const openFile = async (path) => {
    setSelected(path);
    setLoading(true);
    try {
      const res = await buildAPI.getFile(buildId, path);
      setContent(res.data.content);
    } catch {
      setContent('// Failed to load file');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="grid md:grid-cols-[280px_1fr] rounded-xl overflow-hidden border"
      style={{ borderColor: 'var(--border)' }}
      data-testid="code-browser"
    >
      <div className="max-h-[520px] overflow-auto py-2" style={{ background: 'var(--surface)' }}>
        <p className="px-4 py-1.5 text-[10px] font-bold uppercase tracking-widest" style={{ color: 'var(--text-muted)' }}>
          {sorted.length} files
        </p>
        {sorted.map((path) => (
          <button
            key={path}
            onClick={() => openFile(path)}
            className="w-full text-left px-4 py-1.5 font-mono text-xs flex items-center gap-2 transition-colors hover:bg-black/5 dark:hover:bg-white/5"
            style={{
              color: selected === path ? 'var(--primary-accent)' : 'var(--text-secondary)',
              background: selected === path ? 'var(--tag-bg)' : 'transparent',
            }}
            data-testid={`code-file-${path.replace(/[/.]/g, '-')}`}
          >
            <FileCode className="w-3.5 h-3.5 shrink-0" />
            <span className="truncate">{path}</span>
          </button>
        ))}
      </div>
      <div className="max-h-[520px] overflow-auto" style={{ background: '#0B1120' }}>
        {loading ? (
          <div className="flex items-center justify-center h-40">
            <Loader2 className="w-5 h-5 animate-spin text-orange-500" />
          </div>
        ) : (
          <pre className="p-5 text-xs leading-relaxed text-slate-200 whitespace-pre-wrap break-words" data-testid="code-content">
            <code>{content || 'Select a file to view its source'}</code>
          </pre>
        )}
      </div>
    </div>
  );
}
